import React, { useState } from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import Card from '../Card';
import CustomerInfo from './CustomerInfo';
import ShippingInfo from './ShippingInfo';
import PaymentInfo from './PaymentInfo';

const TABS = ['CUSTOMER', 'SHIPPING', 'PAYMENT'];

export default function InfoCard() {
  const [tab, setTab] = useState(TABS[0]);

  return (
    <Card className={styles.container}>
      <UiKit.Tabs size="lg" value={tab} onChange={setTab}>
        <UiKit.Tabs.Tab label="Customer" value={TABS[0]} />
        <UiKit.Tabs.Tab label="Shipping" value={TABS[1]} />
        <UiKit.Tabs.Tab label="Payment" value={TABS[2]} />
      </UiKit.Tabs>
      <div className={styles.content}>
        {tab === TABS[0] && <CustomerInfo />}
        {tab === TABS[1] && <ShippingInfo />}
        {tab === TABS[2] && <PaymentInfo />}
      </div>
    </Card>
  );
}
